import { useCallback, useState } from 'react';

const useRemoveModalControls = <TEntity extends unknown>() => {
  const [entityToRemove, setEntityToRemove] = useState<TEntity | null>(null);
  const [rowToRemoveIndex, setRowIndex] = useState<number | null>();

  const [isRemoveModalVisible, setModalVisible] = useState<boolean>(false);

  const showModalForRemove = useCallback((
    { entityToRemove, rowIndex } : { entityToRemove: TEntity, rowIndex: number }
  ) => {
    setEntityToRemove(entityToRemove);
    setRowIndex(rowIndex);
    setModalVisible(true);
  }, [setEntityToRemove]);

  const hideModalForRemove = useCallback(() => {
    setEntityToRemove(null);
    setRowIndex(null);
    setModalVisible(false);
  }, [setEntityToRemove]);

  return {
    entityToRemove,
    rowToRemoveIndex,
    isRemoveModalVisible,
    showModalForRemove,
    hideModalForRemove,
  };
};

export default useRemoveModalControls;
